<div class="content">
    <h3 class="icon-title">
        <mat-icon class="mat-icon-alert">error</mat-icon>
        <span class="title-alert">Atenção</span>
    </h3>

    <div class="description-alert">
        <p>
            As pré-cargas abaixo possuem entregas em zona de risco. A roteirização será realizada de forma que as entregas em zona de risco sejam as últimas a serem realizadas.
        </p>
    </div>

    <mat-dialog-content class="mat-typography">
        <table mat-table [dataSource]="dataSource">

            <ng-container class="column-destinoPreCarga" matColumnDef="destino">
                <th mat-header-cell *matHeaderCellDef nowrap> Destino - Pré-Carga &nbsp;&nbsp;&nbsp;</th>
                <td mat-cell *matCellDef="let element"> {{ element?.destino }}
                 <br>&nbsp;&nbsp;&nbsp; Clientes: <br>
                 <ul>
                    <div *ngFor="let entrega of element?.listaEntregas">
                        <li *ngIf="entrega?.zonaRisco" >&nbsp;&nbsp;&nbsp; {{entrega?.idCliente}} - {{entrega?.nome}} </li>
                    </div>
                 </ul>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </mat-dialog-content>

    <mat-dialog-actions  class="mt-2 mat-dialog-actions">
        <button  mat-raised-button color="warn"  [mat-dialog-close]="false" >
            <mat-icon>close</mat-icon>
            CANCELAR
        </button >
        <button mat-raised-button color="primary" [mat-dialog-close]="true">
            <mat-icon>check</mat-icon>
            CONFIRMAR
        </button>
    </mat-dialog-actions>
</div>
